import Heroc from "../../../component/hero/heroc.jsx";
import Aboutc from "../../../component/about/aboutc.jsx";
import Promoc from "../../../component/promo/promoc.jsx";
import Carouselfasc from "../../../component/carouselfas/carouselfasc.jsx";
import fas from "../../../component/carouselfas/carouselfasc.json";
import prmo from "../../../component/promo/promocard.json";
import dataproduk from "../../../component/cardprodukdetail/cardprodukdetail.json";
import hsimages from "../../../asset/hardsell/hsimages.js";
import data from "../../data.json";
import Heroimages from "../../../asset/hero/heroimages.js";
import Cardprodukdetail1 from "../../../component/cardprodukdetail/cardprodukdetail1.jsx";
import fasizzi from "../../../asset/fascarousel/fas-izzi/fas-izzi.js";
import imgIzzi5 from "../../../asset/imgrumah/img-izzi/img-izzi5/img-izzi5.js";
import imgIzzi6 from "../../../asset/imgrumah/img-izzi/img-izzi6/img-izzi6.js";
import imgIzzispazzia from "../../../asset/imgrumah/img-izzi/img-izzispazzia/img-izzispazzia.js";
const imgMap = {
  fasizzi,
};
const imageMap = {
  imgIzzi5,
  imgIzzi6,
  imgIzzispazzia,
};

const izzi = () => {
  return (
    <div className="izzi">
      <div className="hero">
        {data.izziab.map((hero, index) => {
          // Determine the logo dynamically
          const fotopromo = Heroimages[hero.imagehero];
          return (
            <Heroc
              key={index}
              imagehero={fotopromo} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="about">
        {data.izziab.map((home, index) => {
          // Determine the logo dynamically
          return (
            <Aboutc
              key={index}
              judul={home.judul}
              subjudul={home.subjudul} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="container-promo">
        {prmo.Izzip.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = hsimages[promo.imagehs];
          return (
            <Promoc
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              details={promo.details}
              whatsappLink={promo.whatsappLink}
              quote={promo.quote} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="carouselfas">
        {fas.fasIzzi.map((slide, index) => {
          return <Carouselfasc key={index} carousel={imgMap[slide.carousel]} />;
        })}
      </div>
      <div className="produkcontainer">
        {dataproduk.izzipr.map((card, index) => {
          return (
            <Cardprodukdetail1
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              titleid={card.titleid}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
    </div>
  );
};

export default izzi;
